import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '@/app/store/hooks';
import {
  logoutStart,
  selectAuthError,
  selectAuthLoading,
  selectHydrated,
  selectIsAdmin,
  selectIsAuthenticated,
  selectIsMegaAdmin,
  selectProfileLoaded,
  selectUser,
} from '../store/authSlice';

export function useAuth() {
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectUser);
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const loading = useAppSelector(selectAuthLoading);
  const hydrated = useAppSelector(selectHydrated);
  const error = useAppSelector(selectAuthError);
  /** False when signed in but GET /users/me failed -- limited access. */
  const profileLoaded = useAppSelector(selectProfileLoaded);
  /** Drives the fixed Organization Setup shell -- see selectIsMegaAdmin. */
  const isMegaAdmin = useAppSelector(selectIsMegaAdmin);
  /** A tenant admin: dashboard and Masters, no Organization Setup at all. */
  const isAdmin = useAppSelector(selectIsAdmin);

  const handleLogout = useCallback(() => {
    dispatch(logoutStart());
  }, [dispatch]);

  return {
    user,
    isAuthenticated,
    loading,
    hydrated,
    error,
    profileLoaded,
    isMegaAdmin,
    isAdmin,
    logout: handleLogout,
  };
}
